module.exports = __webpack_public_path__ + "static/media/EU-SRR.22be1b94.pdf";